import { CAR_MODELS } from '../modelCatalog';

interface PartSwitcherProps {
  currentModel: string;
  onSelect: (path: string) => void;
}

export default function PartSwitcher({ currentModel, onSelect }: PartSwitcherProps) {
  return (
    <div className="part-switcher">
      {CAR_MODELS.map((part) => (
        <button
          key={part.path}
          className={`part-button ${currentModel === part.path ? 'active' : ''}`}
          onClick={() => onSelect(part.path)}
          data-testid={`part-btn-${part.name.toLowerCase().replace(/\s+&?\s*/g, '-')}`}
        >
          <span className="part-icon">{part.icon}</span>
          <span className="part-name">{part.name}</span>
        </button>
      ))}
    </div>
  );
}
